import { createStore, combineReducers, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import thunk from 'redux-thunk';

import plantsReducer from './plants';
import reactorsReducer from './reactors';
import productionsReducer from './productions';
import mixReducer from './mix';
import unavailabilitiesReducer from './unavailabilities';
import riversReducer from './rivers';
import usNPPsReducer from './usNPPs';

const rootReducer = combineReducers({
  plants: plantsReducer,
  reactors: reactorsReducer,
  productions: productionsReducer,
  mix: mixReducer,
  unavailabilities: unavailabilitiesReducer,
  rivers: riversReducer,
  usNPPs: usNPPsReducer,
});

const enhancers = [applyMiddleware(thunk)];
const composeEnhancers = composeWithDevTools({});
const enhancer = composeEnhancers(...enhancers);

// Initial state: ensure mix is always defined as an object
const initialState = {
  mix: {},
};

const store = createStore(rootReducer, initialState, enhancer);

export default store;
